import { format } from '@office-start/string-formatter-utility';
import { GenerateShareLinkUrlFormat } from '../constants';
export const generateShareLink = (linkParams, appId, tabEntityId) => {
    const url = new URL(`${window.location.origin}`);
    url.pathname = format(GenerateShareLinkUrlFormat, "m365apps" /* RoutePaths.M365Apps */, appId, tabEntityId, linkParams.subEntityId);
    //pass the subPageId through query parameters to prevent it from converted to lowercase
    url.searchParams.append('subPageId', linkParams.subEntityId);
    return url.toString();
};
//# sourceMappingURL=generateShareLink.js.map